import cx from 'classnames';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { SLATE_THEME_OVERRIDE_COOKIE } from '|/context/slate-context';
import styles from './control-panel.module.css';

const SlateOverrides = () => {
  const [showInterface, setShowInterface] = useState(false);
  const [isThemeOverrideEnabled, setIsThemeOverrideEnabled] = useState(
    () => Cookies.get(SLATE_THEME_OVERRIDE_COOKIE) === 'true'
  );

  if (process.env.NODE_ENV === 'production') return null;

  const hasAnyOverride = isThemeOverrideEnabled;

  const handleThemeChange = (enabled: boolean) => {
    setIsThemeOverrideEnabled(enabled);
    if (enabled) {
      Cookies.set(SLATE_THEME_OVERRIDE_COOKIE, 'true');
    } else {
      Cookies.remove(SLATE_THEME_OVERRIDE_COOKIE);
    }
    window.location.reload();
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={cx(styles.tab, showInterface && styles.expanded)}
        onClick={() => {
          setShowInterface(current => !current);
        }}
        data-analytics-id="pp_devpanel_slate_header"
      >
        {hasAnyOverride && <span className={styles.tabIndicatorDot} />}
        Slate
      </button>
      {showInterface && (
        <div className={styles.content}>
          <div className={styles.groupLabel}>Theme</div>
          <label htmlFor="slate-theme-vehicle-default" className={styles.radio}>
            <input
              type="radio"
              name="slate-theme-override"
              id="slate-theme-vehicle-default"
              checked={!isThemeOverrideEnabled}
              onChange={() => {
                handleThemeChange(false);
              }}
              data-analytics-id="pp_devpanel_slate_theme_default"
            />
            <div>vehicle default</div>
          </label>
          <label htmlFor="slate-theme-force-slate" className={styles.radio}>
            <input
              type="radio"
              name="slate-theme-override"
              id="slate-theme-force-slate"
              checked={isThemeOverrideEnabled}
              onChange={() => {
                handleThemeChange(true);
              }}
              data-analytics-id="pp_devpanel_slate_theme_force"
            />
            <div>force slate</div>
          </label>
        </div>
      )}
    </div>
  );
};

export default SlateOverrides;
